import { createSlice } from '@reduxjs/toolkit';

const documentosSlice = createSlice({
  name: 'documentos',
  initialState: {},
  reducers: {
    carregarDocumentos: (state, action) => {
      const { idProcessoItem, documentos } = action.payload;
      state[idProcessoItem] = documentos; // sobrescreve diretamente
    },
    limparDocumentos(state, action) {
      delete state[action.payload];
    }
  },
});

export const { carregarDocumentos, limparDocumentos } = documentosSlice.actions;

export default documentosSlice.reducer;
